// extracted by mini-css-extract-plugin
export default {"header":"style_header__FA-9C","container":"style_container__Q47b1","title":"style_title__Tx-yy","description":"style_description__0MxC6"};